<template>
  <th class="tab-element" :class="{ tiny, big }">
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: 'table-header',

  props: {
    tiny: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
